// 获取当前页面的 URL
const currentUrl = window.location.pathname;

// 判断是否是首页
if (currentUrl !== '/' && currentUrl !== '/index.html') {
    // 如果不是首页，给 div 添加下划线样式
    let header = document.querySelector('sticky-header')
    if (header) header.style.borderBottom = '1.5px solid'
}
